import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=5c681db2&"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js&"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports